import { render, staticRenderFns } from "./DefaultOLCEditConfirmation.vue?vue&type=template&id=57af117a&lang=pug&"
import script from "./DefaultOLCEditConfirmation.vue?vue&type=script&lang=ts&"
export * from "./DefaultOLCEditConfirmation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports